import type { FormattedTipsAndTrick } from 'types/AlgoliaResults';
import { type SearchResultCard, getRecipeImages } from '..';
import type { PathTranslations } from 'service/localization/getPathTranslations';

export const mapAlgoliaTipsToSearchCard = (
  tip: FormattedTipsAndTrick,
  labels: Record<string, string>,
  pathTranslations: PathTranslations,
): SearchResultCard => ({
  resultType: 'tipsAndTricks',
  id: tip.id,
  title: tip.title,
  description: tip.description,
  category: tip.category,
  images: getRecipeImages(tip.images),
  link: {
    url: `${pathTranslations.tipAndTrick}${tip.slug}`,
    displayName: labels.see_details || 'See details',
  },
});
